import constClass from '../../Constants/Constants';
import Common from '../Common/common';
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const RankUp = ({ siteId, mallId, shopCode, customerId, liffAccessToken, benefitClick, detailClick, royaltyseenClick }) => {
  const [rankCustomerInfo, setRankCustomerInfo] = useState(null);
  const [benefitLotteryTicketList, setBenefitLotteryTicketList] = useState([]);
  const [benefitLotteryTicketMasterList, setBenefitLotteryTicketMasterList] = useState([]);

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      const benefit_lottery_ticket_list = axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${siteId}/issuelist/`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      //会員名を取得
      //自分の会員ランク情報を取得
      const rank_customer_data = (await rank_customer_info_promise).data;
      //ランクアップ特典の抽選券リストを取得
      const benefit_lottery_ticket_list_data = (await benefit_lottery_ticket_list).data;
      const benefit_lottery_ticket_master_list = axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${siteId}/`);
      const benefit_lottery_ticket_master_list_data = (await benefit_lottery_ticket_master_list).data;
      setBenefitLotteryTicketMasterList(benefit_lottery_ticket_master_list_data);
      setBenefitLotteryTicketList(benefit_lottery_ticket_list_data);
      setRankCustomerInfo(rank_customer_data);

      if (benefit_lottery_ticket_list_data && benefit_lottery_ticket_list_data.find(x => x.royalty_seen_flag !== constClass.FLAG.ON)) {
        const params = { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId };
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/line/royaltyseen/`, params);
        royaltyseenClick();
      }
    } catch (err) {
      console.log(err);
    }
  }, [siteId, mallId, customerId, liffAccessToken, royaltyseenClick]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div id="ticketList" className="ticket-list">
      <div className='rankupframe29 mb-2 mt-4'>
        {(rankCustomerInfo && rankCustomerInfo.rank_id === 1) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/bronzecrown.png`} alt={'冠'} />
              <div className="rankupicontext">ブロンズ</div>
            </React.Fragment>
          </div>
        }
        {(rankCustomerInfo && rankCustomerInfo.rank_id === 2) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/silvercrown.png`} alt={'冠'} />
              <div className="rankupicontext">シルバー</div>
            </React.Fragment>
          </div>
        }
        {(rankCustomerInfo && rankCustomerInfo.rank_id === 3) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/goldcrown.png`} alt={'冠'} />
              <div className="rankupicontext">ゴールド</div>
            </React.Fragment>
          </div>
        }
        {(rankCustomerInfo && rankCustomerInfo.rank_id === 4) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/platinumcrown.png`} alt={'冠'} />
              <div className="rankupicontext">プラチナ</div>
            </React.Fragment>
          </div>
        }
        {(rankCustomerInfo && rankCustomerInfo.rank_id === 5) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/vipcrown.png`} alt={'冠'} />
              <div className="rankupicontext">VIP</div>
            </React.Fragment>
          </div>
        }
        <div className="rankup_congrats my-3">{rankCustomerInfo && (rankCustomerInfo.rank_id === 1 ? "ブロンズ" : rankCustomerInfo.rank_id === 2 ? "シルバー" : rankCustomerInfo.rank_id === 3 ? "ゴールド" : rankCustomerInfo.rank_id === 4 ? "プラチナ" : rankCustomerInfo.rank_id === 5 ? "VIP" : "ブロンズ")}ランクおめでとうございます!</div>
        <p className="applied-notice mt-2" style={{ fontSize: '0.75rem', color: '#555', lineHeight: '1.6' }}>
          ※当選通知は8月以降にLINEメッセージ配信にてご連絡します。<br />
          　当選者のみへの通知となります。<br />
          　LINEお友だち登録をブロックをしていた場合は<br />
          　通知が届きませんのでご了承ください。
        </p>
        {benefitLotteryTicketList.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0 && <div className="select_benefit">以下賞品に抽選の応募ができます</div>}
        {/* <div className="lottery_ticket_count mt-2">
          残り抽選券：<b className="ticket-count">{benefitLotteryTicketList.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0 ? benefitLotteryTicketList.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length : 0}枚</b>
        </div> */}
      </div>
      {benefitLotteryTicketMasterList && (() => {
        // APPLIEDのチケットをbenefit_lottery_ticket_idごとにグループ化
        const appliedTickets = benefitLotteryTicketList.filter(
          ticket => ticket.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED
        );
        const grouped = appliedTickets.reduce((acc, ticket) => {
          const id = ticket.benefit_lottery_ticket_id;
          if (!acc[id]) acc[id] = [];
          acc[id].push(ticket);
          return acc;
        }, {});

        // グループが1つ以上あれば表示
        if (Object.keys(grouped).length === 0) return null;

        return (
          <div className="applied-benefit-section mb-4">
            <h5 className="applied-benefit-title my-2">応募済みの特典</h5>
            {Object.entries(grouped).map(([id, tickets]) => {
              const benefit = benefitLotteryTicketMasterList.find(
                b => Number(b.benefit_lottery_ticket_id) === Number(id)
              );
              return (
                <React.Fragment key={id}>
                  <div className="rankupbenefit">
                    <div className='benefit-frame39'>
                      <div className="benefit_title mt-3">{benefit?.benefit_lottery_ticket_title}</div>   
                    </div>
                    <div className='benefit-frame42'>
                      {benefit?.benefit_lottery_ticket_image_url ?
                        <img className="benefit-image" src={`/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_IMAGE_DIR}${benefit.benefit_lottery_ticket_image_url}`} alt={benefit?.benefit_lottery_ticket_title} style={{ objectFit: 'cover' }} />
                        :
                        <img className="benefit-image" src={`/${siteId}/noimage.png`} alt="noimage" style={{ objectFit: 'cover' }} />
                      }
                      <div className='frame41'>
                        <div className="ticket-detail">{Common.getBrString(benefit?.benefit_lottery_ticket_summary)}</div>
                        <button
                          onClick={() => benefitClick(benefit.benefit_lottery_ticket_id)}
                          className="button text-black bg-lightwhite"
                          disabled
                          style={{ opacity: 0.6, cursor: 'not-allowed' }}
                        >
                          応募済み
                        </button>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        );
      })()}
      <div className="group29">
        {benefitLotteryTicketMasterList && benefitLotteryTicketMasterList.filter(benefit => benefitLotteryTicketList.filter(ticket => ticket.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED).some(ticket => Number(ticket.benefit_lottery_ticket_id) === Number(benefit.benefit_lottery_ticket_id))).length > 0 && benefitLotteryTicketList.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0 && (
          <h5 className="can-apply-benefit-desc mt-4">
            以下の特典に応募ができます。
          </h5>
        )}
        {benefitLotteryTicketList.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0 && benefitLotteryTicketMasterList && benefitLotteryTicketMasterList.map(benefit =>
          <React.Fragment key={benefit.benefit_lottery_ticket_id}>
            <div className="rankupbenefit">
              <div className='benefit-frame39'>
                <div className="benefit_title mt-3">{benefit.benefit_lottery_ticket_title}</div>                
              </div>
              <div className='benefit-frame42'>
                {benefit.benefit_lottery_ticket_image_url &&
                  <img className="benefit-image" src={`/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_IMAGE_DIR}${benefit.benefit_lottery_ticket_image_url}`} alt={benefit.benefit_lottery_ticket_title} style={{ objectFit: 'cover' }} />
                }
                {!benefit.benefit_lottery_ticket_image_url &&
                  <img className="benefit-image" src={`/${siteId}/noimage.png`} alt="noimage" style={{ objectFit: 'cover' }} />
                }
                <div className='frame41'>
                  <div className="ticket-detail">{benefit.benefit_lottery_ticket_summary}</div>
                  <button
                    onClick={() => benefitClick(benefit.benefit_lottery_ticket_id)}
                    className="button text-black bg-lightwhite">
                    賞品の詳細・応募に進む
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default RankUp;